// 把views文件夹下的文件自动生成路由
import layout from '@/layout/layout.vue';
const viewsPathList = import.meta.glob(['../*iews/**/*.vue', '!../*iews/**/components/*.vue']);
const routes: any = [
    { name: '/', path: '/', component: layout, children: [], redirect: '/home' },
    { path: '/:pathMatch(.*)*', name: 'NotFound', redirect: '/home' },
];

Object.keys(viewsPathList).forEach(item => {
    const realKey = item?.replace?.('../views', '')?.replace?.('.vue', '');
    const name = realKey.split('/').slice(-1)[0].toLocaleLowerCase();

    const route = { name, path: realKey, component: viewsPathList[item] };
    if (name === 'login') {
        routes.push(route);
    } else {
        routes[0].children.push(route);
    }
});
export const listRouter = routes;
